// extracted by mini-css-extract-plugin
module.exports = {"container":"OtherDeviceSignedIn_container__15sbK","msg":"OtherDeviceSignedIn_msg__kV8se","confirmBtn":"OtherDeviceSignedIn_confirmBtn__3IImv"};